import './App.css';
import { Routes, Route, useLocation, Navigate, Link } from 'react-router-dom';
import { Box, Button, Container, HStack, Image, Text, VStack } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import Masleka from './pages/masleka';
import Masleka32 from './pages/masleka32';
import MaslekaFr from './pages/maslekaFr';
import ClientC from './pages/clientC';


export default function App() {

  const [initData, setInitData] = useState(null);

  return (
    <Container variant={"layout"}>
      <Container as="header" variant={"header"}>
        <Link to={"http://www.el-ad.co.il"} target='_blank'>
          <Image src={initData?.organizationIconUrl} h="80px" alt={`לוגו ${initData?.name}`} />
        </Link>
      </Container>
      <Container as="main" variant={"main"}>
        <Routes>
          <Route path="/" element={<Navigate to="/masleka/:guid" />} />
          <Route path="/masleka/:guid" element={<Masleka initData={(data) => setInitData(data)}/>} />
          <Route path="/masleka32/:guid" element={<Masleka32 initData={(data) => setInitData(data)}/>} />
          <Route path="/maslekaFr/:guid" element={<MaslekaFr initData={(data) => setInitData(data)}/>} />
          <Route path="/client/:guid" element={<ClientC initData={(data) => setInitData(data)}/>} />
        </Routes>
      </Container>
    </Container>
  );
}
